<template>
  <el-upload
    class="uploader-desktop"
    ref="uploader"
    drag
    multiple
    accept="image/*"
    action="#"
    :auto-upload="false"
    :show-file-list="false"
    v-loading="loading"
    :on-change="onBeforeUpload"
  >
    <slot>
      <div class="uploader-desktop__icon">
        <i class="yk-plus"></i>
      </div>
      <div class="uploader-desktop__tip">上传或拖拽图片</div>
    </slot>
  </el-upload>
</template>
<script>
export default {
  name: 'UploaderDesktop',
  props: {
    // 文件列表
    fileList: {
      type: Array,
      default: () => [],
    },
    // 上传文件最大数量
    uploadLimit: Number,
    // 最大图片大小，单位MB
    maxSize: { type: Number, default: 15 },
  },
  data() {
    return {
      // 上传状态
      loading: false,
      // 图片的原始数据
      uploadFileDatas: [],
    };
  },
  methods: {
    /**
     * 图片上传前
     */
    onBeforeUpload(file) {
      this.uploadFileDatas.push(file.raw);

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.onHttpRequest();
      }, 0);
    },
    /**
     * 上传图片
     */
    onHttpRequest() {
      if (this.uploadFileDatas.some(file => file.size > this.maxSize * 1024 * 1024)) {
        this.uploadFileDatas = [];
        return this.$warning(`单张图片不能超过${this.maxSize}MB`);
      }

      if (this.uploadLimit && this.uploadFileDatas.length + this.fileList.length > this.uploadLimit) {
        this.uploadFileDatas = [...this.uploadFileDatas].slice(0, this.uploadLimit - this.fileList.length);
        this.$warning(`最多上传${this.uploadLimit}张图片（默认选择前${this.uploadLimit}张）`);
      }

      this.loading = true;
      Promise.all(
        this.uploadFileDatas.map(file => {
          const formData = new FormData();
          formData.append('file', file);
          return this.$axios.post('/media/v1/upload2', formData).then(({ data: fileList }) => {
            if (fileList && fileList.length) {
              this.$emit('update:fileList', [...this.fileList, ...fileList]);
              this.$emit('success', [...fileList]);
            }
          });
        }),
      ).finally(() => {
        this.loading = false;
        this.uploadFileDatas = [];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.uploader-desktop {
  ::v-deep {
    .el-upload-dragger {
      box-sizing: border-box;
      width: 150px;
      height: 135px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}
.uploader-desktop__icon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: var(--primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    font-size: 24px;
    color: #fff;
  }
}
.uploader-desktop__tip {
  font-size: 16px;
  line-height: 22px;
  margin-top: 15px;
}
</style>
